











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ErrorMessage extends Vue {
  @Prop() value?: any;

  get message() {
    const response = this.value && this.value.response;
    const msg = response && response.data && response.data.message;
    return msg || 'Unknown error';
  }
}
